//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LocationAddressInputItem } from './LocationAddressInputItem';
import { LocationAddressType, WhiteboardSpaceMode } from './Enums';

export class LessonspaceAddressInputItem extends LocationAddressInputItem {
    override readonly AddressType: LocationAddressType = LocationAddressType.Lessonspace;
    ApiKey: string | null = null;
    SpaceMode: WhiteboardSpaceMode = WhiteboardSpaceMode.EventSeries;

    constructor(initializer?: Partial<Omit<LessonspaceAddressInputItem, "AddressType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "LessonspaceAddressInputItem";
}
